module.exports = __webpack_public_path__ + "img/login2.c96dde84.png";